import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Modal, Spin, Select,message } from "antd";
import { postDo, getclientslist } from '../../Services/Services';

const DoEntry = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [clientID, setClientId] = useState([]);
    const [form] = Form.useForm();

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async (values) => {
        setLoading(true);
        Object.assign(values, { 'rem_qty': values.quantity ,'com_name':localStorage.getItem('com_name')})
        const response = await postDo(values);
        setLoading(false);
        if (response) {
            const sortedArray = [...response].sort((a, b) => b.id - a.id);
            message.success('DO Entry Successful');
            props.setDeliveryOrder(sortedArray);
            props.setorderList(sortedArray);
            setIsModalOpen(false);
            form.resetFields();
        } else {
            message.warning('DO Entry Not Successful');
        }
    };
    useEffect(() => {
        Getclientslist()
    }, [])
    const Getclientslist = async () => {
        const response = await getclientslist();
        if (response) {
            const filterData = response.client_list.filter(o =>o.com_name===localStorage.getItem('com_name'))
            setClientId(filterData)
        }
    }
    const handleStartDateChange = (e) => {
        const startDate = e.target.value;

        if (startDate) {
            const formattedEndDate = new Date(startDate);
            formattedEndDate.setDate(formattedEndDate.getDate() + 44);
            const do_end_date = formattedEndDate.toISOString().split('T')[0];
            form.setFieldsValue({
                do_end_date
            })
        }
    };
    return (
        <>
            <Modal
                visible={loading} // Correct prop name is visible, not open
                footer={null}
                closable={false}
                width={400}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img src='transduniyalogo.png' alt='img' width={200} style={{ margin: "10px" }} />
                    <Spin />
                    <h2>DO Creating......</h2>
                </div>
            </Modal>

            <Button
                onClick={showModal}
                type='primary'
                ghost
                style={{
                    margin: "10px",
                    backgroundColor: 'black',
                    color: 'white',
                    fontWeight: '600'
                }}
            >
                Add New DO
            </Button>

            <Modal
                visible={isModalOpen} // Correct prop name is visible, not open
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}

            >
                <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                

                    <Form.Item
                        name="client_id"
                        rules={[
                            {
                                required: true,
                                message: "Please  Party Name !",
                            },
                        ]}
                        label={<b>Party Name</b>}
                        style={{ padding: '0px', margin: "1px" }}
                    >
                        <Select
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                        >
                            {clientID.map((client) => (
                                <Select.Option value={client.client_id}>
                                    {client.client_name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Do No!",
                            },
                        ]}
                        name="do_no"
                        label={<b>DO No</b>}
                        style={{ padding: '0px', margin: "1px" }}
                    >
                        <Input placeholder="DO No" maxLength={15} />
                    </Form.Item>

                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Do start Date!",
                            },
                        ]}
                        name="do_start_date"
                        label={<b>DO Start Date</b>}
                        style={{ padding: '0px', margin: "1px" }}
                    >
                        <Input placeholder="DO Start Date" type="date" onChange={handleStartDateChange} />
                    </Form.Item>
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Do End Dte!",
                            },
                        ]}
                        name="do_end_date"
                        label={<b>DO End Date</b>}
                        style={{ padding: '0px', margin: "1px" }}
                    >
                        <Input placeholder="DO End Date" type="date" />
                    </Form.Item>
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Mines Name!",
                            },
                        ]}
                        name="mines_name"
                        label={<b>Mines Name</b>}
                        style={{ padding: '0px', margin: "1px" }}
                    >
                        <Input placeholder="Mines Name" />
                    </Form.Item>




                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Quantity!",
                            },
                        ]}
                        name="quantity"
                        label={<b>Quantity (Ton)</b>}
                        style={{ padding: '0px', margin: "1px" }}
                    >
                        <Input placeholder="Quantity" type="number" />
                    </Form.Item>

                    <Form.Item className="text-center"
                        style={{ textAlign: 'center', padding: '0px', margin: "2px" }}
                    >
                        <Button
                            htmlType="submit"
                            style={{ color: "white", backgroundColor: 'black' }}
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default DoEntry;
